import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const navigationContent = [
  {
    name: "Work",
    pathname: "/"
  },
  {
    name: "About",
    pathname: "/about"
  },
];

class Navigation extends Component {
  // scroll event!
  constructor(props){
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      activeStyle: false,
      currentMenu: navigationContent[0].name
    };
  }

  componentDidMount(){
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('click', this.handleClick);
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('click', this.handleClick);
  }

  handleScroll(event){
    const scrollYposition = window.scrollY;
    const barHeight = document.querySelector(".header").offsetHeight * 3;

    if (scrollYposition > barHeight && !this.state.activeStyle) {
      // console.log("Change to active style!");
      this.setState({ activeStyle: true });
    } else if (scrollYposition <= 0 && this.state.activeStyle) {
      // console.log("Keep old style!");
      this.setState({ activeStyle: false });
    }
  }

  handleClick(event){
    const menuName = event.target.name;
    // this.setState({currentMenu: menuName});

    if(this.state !== menuName){
      // change to selected state
      this.setState({currentMenu: menuName});
    }
  }


  render(){
    // Switch state
    const { activeStyle } = this.state;
    const headerClass = activeStyle ? 'header active' : 'header';
    const logoClass = activeStyle ? 'logo active' : 'logo';
    const listClass = activeStyle ? 'link link-nav active': 'link link-nav';

    const navItems = navigationContent.map(item => {
        const { currentMenu } = this.state;
        const linkClass = item.name === currentMenu ? `${listClass} selected` : `${listClass}`;

      return (
        <li key={item.name} onClick={this.handleClick}>
          <Link name={item.name} className={linkClass} to={item.pathname} >
            {item.name}
          </Link>
        </li>
      );
    });

    return(
      <header className={headerClass}>
        <div className="container">
          <a className={logoClass} href="/">
            <span className="logo__image" alt="logo"></span>
          </a>

          <nav className="nav-main">
            <ul className="list-inline list-menu">
              {navItems}
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/layout/navigation/Navigation.js